import {Space, Button, Typography} from 'antd';
import { useIntl } from 'react-intl';

interface CaptivePortalActionVariables {
  CP_REDIRECT_URL: string;
}

export function CaptivePortalAction (props: { data: CaptivePortalActionVariables }) {
  const { data } = props
  const { $t } = useIntl()
  return (
    <Space direction="vertical" align="center">
      <Typography.Text>{$t({ defaultMessage: 'You are now connected' })}</Typography.Text>  
      <br></br>
      <br></br>
       <Button style={{ minWidth: '120px' }} 
       onClick={() => window.location.replace(data.CP_REDIRECT_URL)}>
         {$t({ defaultMessage: 'Ok' })}  
       </Button>
    </Space>  
  )
}

export default CaptivePortalAction